export default __webpack_public_path__ + "static/media/juno.96f536ed.svg";